// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"promotional-progress-bar-element_wrapper__MeYKS"};